<template>
  <div class="agentDetail_warpper">
    <nav-bar titleText="解债订单" @goBack="goBack" :isFixed="true"></nav-bar>
    <div class="content1">
      <div class="content-box">
        <!-- <div class="detail_title" v-if="dataSource.status!==60">{{process_status}}</div> -->
        <div class="detail_title">{{process_status}}</div>
        <van-row class="introduce_row">
        <van-col class="debtor_introduce" span="10">
          <div class="introduceBody">
            <p class="introduce_type">债务人</p>
            <p class="introduce_name" v-if="dataSource.debtor_name || dataSource.debtor_company_name">
              {{is_supplement== 1 ? dataSource.debtor_name : (dataSource.debtor_name || dataSource.debtor_company_name) | formatName}}
            </p>
            <p class="introduce_tel">{{dataSource.debtor_mobile }}</p>
            <p class="introduce_code">{{code}}</p>
          </div>
        </van-col>
        <van-col class="process" span="4">
          <div class="processBody">
            <p class="reimbursement">还款</p>
            <div class="process_icon">
              <van-icon class="phase" name="play" :style="{ color: '#b3b0b0'}" />
              <van-icon class="phase" name="play" :style="{ color: '#848181'}" />
              <van-icon class="phase" name="play" :style="{ color: '#3a3939'}" />
            </div>
          </div>
        </van-col>
        <van-col class="creditors_introduce" span="10">
          <div class="creditorsBody">
            <p class="introduce_type">债权人</p>
            <p class="introduce_name">{{dataSource.creditor_name }}</p>
            <p class="introduce_tel">{{dataSource.creditor_mobile}}</p>
            <p class="introduce_code">{{IDCard}}</p>
          </div>
        </van-col>
        </van-row>
      </div>

      <div class="order_details">
        <p class="order_title">订单详情<span class="red-text" v-show="is_supplement == 1">(补录)</span></p>
        <p class="order_content">解债金额 ¥{{dataSource.sum}}</p>
        <p class="order_content">劳务费 ¥{{dataSource.agent_profit}}</p>
        <p class="order_content">经纪人代码 {{dataSource.agent_code}}</p>
        <div class="ordersn">
          <div class="left">
            <span>订单号&nbsp;</span>
            <span ref="copytxt">{{dataSource.order_sn}}</span>
          </div>
          <div class="right" @click="copyOrdersn">复制</div>
        </div>


        <p class="order_content" v-show="is_supplement == 0">创建订单时间 {{dataSource.created_at}}</p> 
        <p class="order_content" v-if="[20,25,30,40,50,60,80,85,90,100,110,130].includes(dataSource.status) && is_supplement== 0" >债权人确认时间 {{dataSource.creditor_confirm_time}}</p>
        <p class="order_content" v-if="[23].includes(dataSource.status) && is_supplement== 0" >债务人确认时间 {{dataSource.debtor_confirm_time}}</p>
        <p class="order_content" v-if="[30, 40, 50, 60, 85, 90, 100, 110,120, 130].includes(dataSource.status)  && is_supplement == 0" >平台审核通过时间 {{dataSource.platform_adopt_time}}</p>
        <p class="order_content" v-if="[40, 50, 60, 90, 100, 110,120, 130].includes(dataSource.status) && is_supplement == 0">财务审核通过时间 {{dataSource.finance_adopt_time}}</p>
        <p class="order_content" v-if="[50, 60, 100, 110,120, 130].includes(dataSource.status) && is_supplement == 0">合同审批通过时间 {{dataSource.contract_adopt_time}}</p>
        <p class="order_content" v-if="[60,120].includes(dataSource.status)&& is_supplement== 0">合同签署完成时间 {{dataSource.effect_time}}</p>
        <p class="order_content" v-if="[60,130].includes(dataSource.status) && is_supplement== 1">合同签署完成时间 {{dataSource.contract_sign_time}}</p>
        <p class="order_content" v-if="[130].includes(dataSource.status) && is_supplement== 1">债权回收完成时间 {{dataSource.debt_complete_time}}</p>
        <p class="order_content" v-if="[70].includes(dataSource.status)">债权人驳回时间 {{dataSource.creditor_reject_time}}</p>
        <p class="order_content" v-if="[75].includes(dataSource.status)">债务人驳回时间 {{dataSource.debtor_reject_time}}</p>
        <p class="order_content" v-if="[80].includes(dataSource.status)">平台驳回时间 {{dataSource.platform_reject_time}}</p>
        <p class="order_content" v-if="[85].includes(dataSource.status)">财务驳回时间 {{dataSource.platform_reject_time}}</p>
        <p class="order_content" v-if="[90].includes(dataSource.status)">合同驳回时间 {{dataSource.platform_reject_time}}</p>
        <p class="order_content" v-if="[100].includes(dataSource.status)">合同撤回时间 {{dataSource.contract_revoke_time}}</p>
        <p class="order_content" v-if="[110].includes(dataSource.status)">合同失效时间 {{dataSource.contract_expire_time}}</p>
        <p class="order_content" v-if="[120].includes(dataSource.status)">合同作废时间 {{dataSource.contract_void_time}}</p>
        
        <p class="order_content" v-if="[70].includes(dataSource.status)" >驳回理由 {{ dataSource.creditor_reject_remark}}</p>
        <p class="order_content" v-if="[75].includes(dataSource.status)" >驳回理由 {{ dataSource.creditor_reject_remark}}</p>
        <p class="order_content" v-if="[80].includes(dataSource.status)" >驳回理由 {{ dataSource.platform_reject_remark}}</p>
        <p class="order_content" v-if="[85].includes(dataSource.status)" >驳回理由 {{ dataSource.platform_reject_remark}}</p>
        <p class="order_content" v-if="[90].includes(dataSource.status)" >驳回理由 {{ dataSource.platform_reject_remark}}</p>

      </div>
    </div>
  </div>
</template>
<script>
import navBar from "../components/navBar";
import uploader from "../components/uploader";
export default {
  name: "debtorDetail",
  data() {
    return {
      percentage: 0,
      code: "",
      IDCard: "",
      show_pivot: false,
      token: "",
      process_status: "",
      amount: 0, //还款金额
      dataSource: {},
      is_supplement:0,
    };
  },
  components: {
    navBar,
    uploader,
  },
  filters: {
    formatName(value) {
      // console.log(value);
      if (value.length <= 8) {
        return value
      }
      if (value.length > 8) {
        return `${value.slice(0, 7)}...`
      }
    },
  },
  created() {
    if (this.$route.query.token) {
      this.$api.setToken(this.$route.query.token);
    }
    this.onLoad();
  },

  mounted() {},
  methods: {
    goBack() {
      // this.$router.push("/agent/agentView");
      if (this.$route.query.debt_from === 'list') {
        this.$router.go(-1)
        return
      }
      this.$router.push('/agent/agentView')
    },
    onLoad() {
      this.$api
        .post("debt/member/agent/detail", {
          id: this.$route.query.account_id
        })
        .then((data) => {
          this.dataSource = data;
          this.is_supplement = data.is_supplement
          this.amount =
            (parseFloat(this.dataSource.amount) * 1000000000000 +
              parseFloat(this.dataSource.interest_amount) * 1000000000000) /
            1000000000000;
          this.percentage =
            parseFloat(this.amount) <= 0
              ? 0
              : (
                  Math.round(
                    (parseInt(this.dataSource.reduction_amount) /
                      parseInt(this.dataSource.amount)) *
                      10000
                  ) / 100.0
                ).toString(); //进度条
          this.code = '****' + String(this.dataSource.debtor_id_number || this.dataSource.debtor_credit_code).slice(-4)
          // console.log(this.dataSource.debtor_credit_code);
          this.IDCard = '****' + this.dataSource.creditor_id_number.slice(-4)
          switch (this.dataSource.status) {
            case 10:
              this.process_status = "待债权人确认";
              break;
            case 13:
              this.process_status = "待债务人确认";
              break;
            case 20:
              this.process_status = "待债权人上传借据凭证";
              break;
            case 23:
              this.process_status = "待债务人上传打款凭证";
              break;
            case 25:
              this.process_status = "待平台审核";
              break;
            case 30:
              this.process_status = "待财务审核";
              break;
            case 40:
              this.process_status = "待合同审批";
              break;
            case 50: //sign_role = 1, //债务，0：都没签 2：债权，
              if (this.dataSource.sign_role === 0) {
                this.process_status = '待合同签名'
              }
              if (this.dataSource.sign_role === 1) {
                this.process_status = '等待债务人签署合同'
              }
              if (this.dataSource.sign_role === 2) {
                this.process_status = '等待债权人签署合同'
              }
              break;
            case 60:
              if(this.is_supplement == 1){
                this.process_status = "已结算";
              }else{
                this.process_status = "已结算";
              }
              break;
            case 70:
              this.process_status = "债权人驳回";
              break;
            case 80:
              this.process_status = "平台驳回";
              break;
            case 85:
              this.process_status = "财务驳回";
              break;
            case 90:
              this.process_status = "合同审批驳回";
              break;
            case 100:
              this.process_status = "合同撤回";
              break;
            case 110:
              this.process_status = "合同失效";
              break;
            case 120:
              if(this.is_supplement == 1){
                this.process_status = "已结算";
              }else{
                this.process_status = "合同作废";
              }
              break;
            case 130:
              this.process_status = "已结算";
              break;
            // default:
            //   this.process_status = "";
          }
        })
        .catch((res) => {});
    },
    copyOrdersn(){
        const agent_range = document.createRange();
        agent_range.selectNode(this.$refs.copytxt);
        const agent_selection = window.getSelection();
        if(agent_selection.rangeCount > 0) agent_selection.removeAllRanges();
        agent_selection.addRange(agent_range);
        document.execCommand('Copy');
        this.$toast('复制成功')
        agent_selection.removeAllRanges()
    },
  },
};
</script>
<style lang="less">
.agentDetail_warpper {
  padding-top: 88px;
  box-sizing: border-box;
  background-color: #f5f6f7;
  min-height: 100%;
  color: #333333;
  // .navbar {
  //   margin: 24px 5px 0 5px;
  // }
  .content1 {
    // margin: 12px;
    .payment_status {
      font-size: 15px;
      height: 30px;
      line-height: 30px;
    }
    .paymentBox {
      margin: 9px 0 15px;
    }
    .has_payment {
      font-size: 24px;
      font-weight: 600;
    }
    .total_amount {
      font-size: 16px;
      color: #999999;
    }
    .van-progress {
      background: rgb(254, 238, 232);
      height: 6px;
      width: 100%;
    }
    .detail_title {
      font-size: 24px;
      font-weight: 600;
      margin: 18px 0 24px 0;
    }
    .content-box {
      padding: 12px 12px 0;
      background: linear-gradient(360deg, #F5F6F7 0%, #FFFFFF 100%);
    }
    .introduce_row {
      margin-bottom: 20px;
      margin-top: 15px;
    }
    .introduceBody,
    .creditorsBody {
      background-color: #fff;
      width: 100%;
      height: 139px;
      -webkit-box-shadow: 0px 0px 1px #000;
      box-shadow: 0px 0px 4px #dedada;
      text-align: center;
      border-radius: 6px;
      .introduce_type {
        color: #999999;
        font-size: 13px;
        padding: 15px 0 6px;
      }
      .introduce_name {
        color: #fc740c;
        font-size: 17px;
        height: 28px;
        font-weight: 600;
        line-height: 28px;
      }
      .introduce_tel {
        font-size: 15px;
        margin: 3px 0;
        height: 24px;
        line-height: 24px;
      }
      .introduce_code {
        color: #999999;
        font-size: 15px;
        padding-bottom: 14px;
        height: 24px;
        line-height: 24px;
      }
    }
    .process {
      text-align: center;
      height: 150px;
      .processBody {
        margin-top: 52px;
        .reimbursement {
          font-size: 15px;
        }
        .process_icon {
          .phase {
            width: 12px;
            height: 12px;
            margin: 6px 0px 0 0;
          }
        }
      }
    }
    .order_details {
      margin: 4px 12px 0;
      // width: 100%;
      background-color: #fff;
      font-size: 14px;
      border-radius: 6px;
      padding-bottom: 9px;
      .order_title {
        color: #999999;
        padding: 15px 0 10px;
        margin-left: 15px;
      }
      .order_content {
        padding-bottom: 6px;
        margin-left: 15px;
        height: 23px;
        line-height: 23px;
      }
      .ordersn {
        display: flex;
        justify-content: space-between;
        align-items: center;
        .left {
          padding-bottom: 6px;
          margin-left: 15px;
          height: 23px;
          line-height: 23px;
        }
        .right {
          height: 23px;
          font-size: 14px;
          color: #F9591B;
          line-height: 23px;
          padding-right: 15px;
        }
      }
      p {
        .van-uploader__preview-image {
          width: 100px;
          height: 100px;
        }
      }
      .uploader {
        margin-left: 15px;
        height: 100px;
        width: 100px;
        margin-top: 3px;
      }
      .rejected {
        margin: 24px 15px 0;
        .operation_btn {
          background-color: #fff;
          color: #333;
          border: 1px solid #666;
        }
      }
      .operation_btn {
        width: 100%;
        /* margin: 24px 15px; */
        height: 50px;
        font-size: 17px;
        display: block;
        border-radius: 30px;
        line-height: 50px;
        font-weight: 600;
      }
    }
  }
  .viewEleContract {
    text-align: center;
    height: 36px;
    line-height: 36px;
    background: #fff;
    margin-top: 4px;
    font-size: 15px;
  }
}
.van-dialog__header {
  font-size: 18px;
  font-weight: bold;
  padding-top: 20px;
  line-height: 25px;
  height: 25px;
  text-align: center;
}
.modalBody {
  height: 160px;
  text-align: center;
  p {
    color: #333333;
    font-size: 15px;
    margin: 8px 0 24px;
  }
  textarea {
    background: #f5f6f7;
    border: none;
    font-size: 16px;
    margin: 0 auto 24px;
    height: 80px;
    letter-spacing: 2px;
    padding: 10px;
    width: 224px;
  }
  span {
    z-index: 9999;
    display: block;
    top: -54px;
    position: relative;
    text-align: right;
    font-size: 16px;
    color: #cccccc;
    width: 270px;
  }
  .van-dialog__confirm,
  .van-dialog__confirm:active {
    color: #f9591b;
  }
}
.red-text{
  color: #f9591b;
}
</style>